import {useApiClient} from "./client";

export function useUiSettingsApi() {
	const api = useApiClient();
	return {
		getUiSettings: () => api.get("/api/v2/ui-settings"),
	};
}
